<template>
    <div class=" bg-transparent-blue">

        <div class="px-3 max-w-3xl m-auto">

            <div v-bind:class="ifLoading" class="loader">
                <TheSpinner />
            </div>
            <div class="lang-de" v-if="loading">
                <Component
                        v-for="articleItem of items"
                        :key="articleItem.ID"
                        :is="getArticleLayout(articleItem.type)"
                        :articleItem="articleItem"
                        parent="article"
                />
            </div>
            <div class="lang-en" v-if="loadingEN">
                <Component
                        v-for="articleItem of itemEN"
                        :key="articleItem.ID"
                        :is="getArticleLayout(articleItem.type)"
                        :articleItem="articleItem"
                        parent="article"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import TheSpinner from "../TheSpinner"
    const countdown = () => import ('../countdown/countdown.vue');
    const news = () => import ('../news/teaserplain.vue');
    const formular = () => import ('../formular/formular.vue');
    const error = () => import ('../error.vue');
    const instagram = () => import ('../instagram/instagram.vue');
    const teilnehmer = () => import ('../teilnehmer/homepageTeaser.vue');
    const spielplan = () => import ('../spielplan/teaser.vue');
    const ergebnisse = () => import ('../ergebnisse/teaser.vue');
    const text = () => import('../TheText');
    const headline = () => import('../TheHeadline');
    const news_image = () => import('../TheImage');
    const youtube = () => import('../TheYouTube');
    const maps = () => import('../TheMaps');
    const news_image_text = () => import('../TheCaption');
    const nav = () => import ('../navigation/pagenav.vue');
    const lead = () => import ('../article/lead.vue');

    export default {
        name: 'homepage',
        components: {
            TheSpinner
        },
        data(){
            return{
                loading: false,
                loadingEN: false,
                items: [],
                itemEN: []
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/newsarticle/'+this.$route.params.id+'.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                        this.loading = true
                })

            const baseURIEN = 'https://api.pgsi2020.de/api/file/newsarticle/'+this.$route.params.en+'.json'
            this.$http.get(baseURIEN)
                .then((result) => {
                    this.itemEN = result.data,
                        this.loadingEN = true
                })
        },
        watch: {
            '$route.params.id': function () {
                this.loading = false;
                const baseURI = 'https://api.pgsi2020.de/api/file/newsarticle/'+this.$route.params.id+'.json'
                this.$http.get(baseURI)
                    .then((result) => {
                        this.items = result.data,
                            this.loading = true
                    })

                const baseURIEN = 'https://api.pgsi2020.de/api/file/newsarticle/'+this.$route.params.en+'.json'
                this.$http.get(baseURIEN)
                    .then((result) => {
                        this.itemEN = result.data,
                            this.loadingEN = true
                    })

            }
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        },
        methods: {
            getArticleLayout(layout) {
                switch (layout) {
                    case 'countdown':
                        return countdown
                    case 'root':
                        return lead
                    case 'news':
                        return news
                    case 'formular':
                        return formular
                    case 'instagram':
                        return instagram
                    case 'teilnehmer':
                        return teilnehmer
                    case 'spielplan':
                        return spielplan
                    case 'ergebnisse':
                        return ergebnisse
                    case 'text':
                        return text
                    case 'headline':
                        return headline
                    case 'news_image':
                        return news_image
                    case 'youtube':
                        return youtube
                    case 'maps':
                        return maps
                    case 'news_image_text':
                        return news_image_text
                    case 'nav':
                        return nav
                    default:
                        return error
                }
            }
        }
    }
</script>

<style lang="scss">
    table{
        max-width: 95% !important;
    }
    </style>
